import React, { useId } from "react";
import FieldError, { fieldErrorBorder } from "../FieldError";
import styles from "./TextArea.module.scss";

/**
 *
 * TextArea
 *
 */
const TextArea = ({
  label = "",
  name = "",
  placeholder = "",
  value = "",
  background = "bg-transparent",
  required = false,
  error = "",
  ...props
}) => {
  const errorId = useId();

  return (
    <div className={styles["text-area"]} {...props}>
      <label htmlFor={name} className="sr-only">
        {label}
      </label>
      <textarea
        name={name}
        id={name}
        placeholder={placeholder || label}
        className={`rounded-3xl lg:rounded-button border border-border-color color-border-border-color w-full h-[200px] flex justify-between items-center px-10 py-8 leading-none text-base sm:text-lg ${background} ${error ? fieldErrorBorder : ""}`}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
      />
      <FieldError id={errorId} message={error} />
    </div>
  );
};

export default TextArea;
